/**
 * @param state {object} Domain state
 * @param contentDepartments {string[]} Content departments
 * @returns {*}
 */
export const saveContentDepartmentsReducer = (state, {contentDepartments}) => {

    state.departments = contentDepartments;

    return state;
};
